import { Navigate, Outlet, useParams, useSearchParams } from 'react-router-dom';
// MUI
import useMediaQuery from '@mui/material/useMediaQuery';
// CUSTOM COMPONENTS
import MobileSidebar from './components/MobileSidebar';
import DashboardHeader from './components/DashboardHeader';
import DashboardSidebar from './components/DashboardSidebar';
import LayoutBodyWrapper from './components/LayoutBodyWrapper';
// import LayoutSetting from 'layouts/layout-parts/LayoutSetting';
// DASHBOARD LAYOUT BASED CONTEXT PROVIDER
import LayoutProvider from './context/layoutContext';
import { useSignalR } from '../../contexts/signalerContext';
import React, { useEffect } from 'react';
import { playNotificationSound } from '../../utils/notificationSound';
import toast from 'react-hot-toast';
import useLocation from '../../hooks/useLocation';
import { dispatch } from '../../store';
import { getTripById } from '../../store/reducers/dashboard/tripsReducer';

const toastContent = (t, text, link) => (
  <div
    style={{ cursor: 'pointer' }}
    onClick={() => (window.location.href = link)}
  >
    <div>{text}</div>
  </div>
);

export default function DashboardLayoutV1({ children }) {
  const downLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const connection = useSignalR();

  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!connection) return;

    if (pathname === '/dashboard/trips') {
      return;
    }

    const handler = (notification) => {
      console.log('Received notification:', notification);
      playNotificationSound();

      if (
        pathname.includes('/dashboard/trip-details') &&
        id === notification.tripId
      ) {
        dispatch(getTripById(id)).catch((error) => console.error('getTripById failed:', error));
      } else {
        let text;
        const updatedAt = notification?.updatedAt
          ? new Date(notification.updatedAt)
          : null;
        const createdAt = notification?.createdAt
          ? new Date(notification.createdAt)
          : null;

        if (
          notification &&
          createdAt &&
          ((updatedAt && updatedAt.getTime() === createdAt.getTime()) ||
            !updatedAt)
        ) {
          text = 'A new trip is created. Click here to see trip details.';
        } else {
          text =
            'There is an update on the trip. Click here to check the details.';
        }

        toast.success(
          (t) =>
            toastContent(
              t,
              text,
              `/dashboard/trip-details/${notification.tripId}`
            ),
          { duration: 5000 }
        );
      }
    };

    connection.on('BlastEvent', handler);

    // Отписка при демонтировании или смене deps
    return () => {
      connection.off('BlastEvent', handler);
    };
  }, [connection, id, pathname]);

  return (
    <LayoutProvider>
      {/* CONDITIONALLY RENDER THE SIDEBAR */}
      {downLg ? <MobileSidebar /> : <DashboardSidebar />}

      <LayoutBodyWrapper>
        {/* DASHBOARD HEADER SECTION */}
        <DashboardHeader />

        {/* MAIN CONTENT RENDER SECTION */}
        {children || <Outlet />}
      </LayoutBodyWrapper>
    </LayoutProvider>
  );
}
